import { CustomWorkConfiguration } from './customWorkConfiguration'
import { features } from './features'
import Flash from './flash'
import { ProfilesConfiguration } from './profilesConfiguration'
import { ProxyCompensationConfiguration } from './proxyCompensationConfiguration'
import Watchlist from './watchlist'

export const TrackLists = new Watchlist()
export const flash = new Flash()

function defaultState() {
    return {
        loginHint: {
            text: '',
            type: 'info',
        },
        flash,
        navigation: {
            rightDrawerOpen: false,
            rightRailOpen: true,
        },
        watchlist: TrackLists,
        rightDrawerContent: null,
        currentEntity: null,
        popover: {
            content: {
                clientX: 0,
                clientY: 0,
                modifiers: {},
                type: null,
                value: null,
            },
            open: false,
        },
        searchModal: {
            open: false,
            search: '',
            tab: null,
        },
        geography: {
            countries: [],
        },
        markets: {
            exchanges: [],
        },
        customWork: new CustomWorkConfiguration(),
        jobRoles: {
            options: [],
        },
        profiles: new ProfilesConfiguration(),
        proxyCompensation: new ProxyCompensationConfiguration(),
        features,
    }
}

const state = defaultState()
state.reset = function () {
    Object.assign(state, defaultState())
}

export default state
